import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled, { withTheme, ThemeProvider } from 'styled-components';
import Header from './header';
import Footer from '../Components/Footer/footer';
import AppRouter from '../AppRouter';
import TooltipModal from '../cruxComponents/utils/TooltipModal';
import Modal from '../Components/UIElements/Modal';
import GetNewUID from '../Pages/GetNewUID';
import SessionStorageServices from '../util/sessionStorageServices';

const Body = styled.main`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  ${({ background }) => `
		background: ${background}
	`}
`;

const Layout = ({
  theme,
  loading,
  // currentPageSeqNumber,
  screenViewport,
  popupDetails,
  activeSubsectionId,
  questionsLayout,
  custCareTel,
  policyExpiry,
  uspsConfig,
}) => {
  const {
    config: {
      theme: { global },
      footer,
      layout,
      customHeader,
    },
  } = theme;

  const pageId = window.location.pathname.split('/')[1] || '';
  let pageLayout = pageId ? layout[pageId] : 'auto';
  // if (loading && currentPageSeqNumber < 1) {
  // 	pageLayout = 'single';
  // }
  if (!layout[pageId]) {
    pageLayout = 'auto';
  }
  if (questionsLayout) {
    pageLayout = questionsLayout;
  }

  // Defines routes which doesn't includes header and footer
  const routesWithoutHeaderAndFooter = ['login', 'view-document'];

  const isSignLoader = global.showSignatureLoader && pageId.toUpperCase() === 'SIGNATURE';
  const sessionLoader = SessionStorageServices.getLocalValue('show_custom_loader');
  const showCustomLoader = (isSignLoader || sessionLoader) && loading;

  return (
    <ThemeProvider theme={ { ...theme, pageId, pageLayout, screenViewport, activeSubsectionId } }>
      <Body background={ global.background }>
        {routesWithoutHeaderAndFooter.includes(pageId) ? (
          <AppRouter />
        ) : (
          <>
            <Header
              name='header'
              layout={ pageLayout }
              background={ global.background }
              screenViewport={ screenViewport }
              loading={ loading }
              customHeader={ customHeader }
            />
            {showCustomLoader ? <GetNewUID /> : <AppRouter />}
            <Footer
              custCareTel={ custCareTel }
              policyExpiry={ policyExpiry }
              footer={ {
                ...footer,
                background: global.footerBackground,
                color: global.footerTextColor,
                removeFooterMargin: global.removeFooterMargin,
                showDisclaimerText: global.showDisclaimerText,
                fontColor: global.fontColor,
                disclaimerBackground: global.background,
              } }
            />
            {popupDetails.show && <TooltipModal />}
            {uspsConfig.showUSPSAddressModel && (
              <Modal
                questionObj={ {
                  response_options: uspsConfig.options,
                  send_individual_questions: true,
                } }
              />
            )}
          </>
        )}
      </Body>
    </ThemeProvider>
  );
};

Layout.propTypes = {
  theme: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ questions, meta }) => ({
  loading: questions.isLoading,
  currentPageSeqNumber: questions.currentPageSeqNumber,
  screenViewport: meta.screenViewport,
  activeSubsectionId: questions.activeSubsectionId,
  questionsLayout: questions.layout,
  custCareTel: questions.custCareTel,
  policyExpiry: questions.policyExpiry,
  popupDetails: get(questions, 'popupDetails', {}),
  uspsConfig: get(questions, 'uspsConfig', {}),
});

export default withTheme(connect(mapStateToProps, null)(Layout));
